var map = {
	"./cavalierblanc.svg": "805b",
	"./cavaliernoir.svg": "c31a",
	"./foublanc.svg": "9b21",
	"./founoir.svg": "6a3c",
	"./logo.svg": "7e14",
	"./pionblanc.svg": "2057",
	"./pionnoir.svg": "cb75",
	"./reineblanc.svg": "b06c",
	"./reinenoir.svg": "7cbd",
	"./roiblanc.svg": "4c5a",
	"./roinoir.svg": "921c",
	"./tourblanc.svg": "5118",
	"./tournoir.svg": "5f71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c08c";